/**
 *
 * @module entry
 * @desc Services SDK entry point.
 *
 */

import Logging from './../logging/entry';
import Account from './account/entry';
import Commerce from './commerce/entry';
import Configuration from './configuration/entry';
import Content from './content/entry';
import CustomerService from './customerService/entry';
import Device from './device/entry';
import Drm from './drm/entry';
import Exception from './exception/entry';
import Media from './media/entry';
import Identity from './identity/entry';
import Internal from './internal/entry';
import Paywall from './paywall/entry';
import Purchase from './purchase/entry';
import Session from './session/entry';
import Subscription from './subscription/entry';
import Token from './token/entry';
import Util from './util/entry';

import HttpClient from './platforms/httpClient';
import Storage from './platforms/storage';
import ServiceEndpoint from './configuration/serviceEndpoint';
import HttpMethod from './configuration/httpMethod';

/**
 *
 * @class Services
 *
 */
export default class Services {

    /**
     *
     * @access public
     * @returns {SDK.Services.Account}
     *
     */
    static get Account() {
        return Account;
    }

    /**
     *
     * @access public
     * @returns {SDK.Services.Commerce}
     *
     */
    static get Commerce() {
        return Commerce;
    }

    /**
     *
     * @access public
     * @returns {SDK.Services.Configuration}
     *
     */
    static get Configuration() {
        return Configuration;
    }

    /**
     *
     * @access public
     * @returns {SDK.Services.Content}
     *
     */
    static get Content() {
        return Content;
    }

    /**
     *
     * @access public
     * @returns {SDK.Services.CustomerService}
     *
     */
    static get CustomerService() {
        return CustomerService;
    }

    /**
     *
     * @access public
     * @returns {SDK.Services.Device}
     *
     */
    static get Device() {
        return Device;
    }

    /**
     *
     * @access public
     * @returns {SDK.Services.Drm}
     *
     */
    static get Drm() {
        return Drm;
    }

    /**
     *
     * @access public
     * @returns {SDK.Services.Exception}
     *
     */
    static get Exception() {
        return Exception;
    }

    /**
     *
     * @access public
     * @returns {SDK.Services.Identity}
     *
     */
    static get Identity() {
        return Identity;
    }

    /**
     *
     * @access private
     * @returns {SDK.Services.Internal}
     *
     */
    static get Internal() {
        return Internal;
    }

    /**
     *
     * @access public
     * @returns {SDK.Logging}
     *
     */
    static get Logging() {
        return Logging;
    }

    /**
     *
     * @access public
     * @returns {SDK.Services.Media}
     *
     */
    static get Media() {
        return Media;
    }

    /**
     *
     * @access public
     * @returns {SDK.Services.Paywall}
     *
     */
    static get Paywall() {
        return Paywall;
    }

    /**
     *
     * @access public
     * @returns {SDK.Services.Purchase}
     *
     */
    static get Purchase() {
        return Purchase;
    }

    /**
     *
     * @access public
     * @returns {SDK.Services.Session}
     *
     */
    static get Session() {
        return Session;
    }

    /**
     *
     * @access public
     * @returns {SDK.Services.Subscription}
     *
     */
    static get Subscription() {
        return Subscription;
    }

    /**
     *
     * @access public
     * @returns {SDK.Services.Token}
     *
     */
    static get Token() {
        return Token;
    }

    /**
     *
     * @access public
     * @returns {SDK.Services.Util}
     *
     */
    static get Util() {
        return Util;
    }

    /**
     *
     * @access private
     * @returns {HttpClient}
     *
     */
    static get HttpClient() {
        return HttpClient;
    }

    /**
     *
     * @access private
     * @returns {Storage}
     *
     */
    static get Storage() {
        return Storage;
    }

    /**
     *
     * @access private
     * @returns {ServiceEndpoint}
     *
     */
    static get ServiceEndpoint() {
        return ServiceEndpoint;
    }

    /**
     *
     * @access private
     * @returns {HttpMethod}
     *
     */
    static get HttpMethod() {
        return HttpMethod;
    }

}



// WEBPACK FOOTER //
// ./src/services/entry.js